import { FC } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { Form } from 'component-lib/atoms/controls/Form';

export interface RatingProps {
  value: number;
  onChange?: (newValue: number) => void;
  disabled?: boolean;
  label?: string;
  hint?: string;
  error?: string;
}

export const MAX_STARS = 5;
export const STAR_FILL = '⭑';
export const STAR_OUTLINE = '⭒';

export const printStars = (rating: number) => {
  const getStarValue = (_: unknown, idx: number) => idx < rating;
  const drawStar = (res: boolean) => (res ? STAR_FILL : STAR_OUTLINE);

  return Array.from({ length: MAX_STARS }, getStarValue).map(drawStar);
};

export const normalizeRating = (rating: number) => {
  return Math.round(rating) > MAX_STARS ? MAX_STARS : rating < 0 ? 0 : Math.round(rating);
};

export const Rating: FC<RatingProps> = ({ value, disabled = true, onChange, label, hint, error }) => {
  const normalizedValue = normalizeRating(value);

  const stars = printStars(normalizedValue);

  const labelText = error || hint;

  return (
    <Form.Group tw="flex flex-col">
      {label && <Form.Label>{label}</Form.Label>}
      <div tw="flex gap-1">
        {stars.map((star, idx) => {
          return (
            <div
              css={[tw`text-3xl text-[#fcba03]`, !disabled && tw`cursor-pointer hover:text-[#fcce03]`]}
              onClick={() => !disabled && onChange?.(idx + 1)}
              key={`${star}+${idx}`}
            >
              {star}
            </div>
          );
        })}
      </div>
      {labelText && <Form.Hint error={!!error}>{labelText}</Form.Hint>}
    </Form.Group>
  );
};
